import classnames from 'classnames';
import React from 'react';
import ownClasses from './ItemTitle.module.scss.js';

const BigTitle = ({ classes = [], children, }) => {
    return (React.createElement("h2", { className: classnames('headline-6', ownClasses['item-title'], ...classes) }, children));
};
const SmallTitle = ({ classes = [], children, }) => {
    return (React.createElement("h2", { className: classnames(ownClasses['item-title'], ...classes) },
        React.createElement("span", { className: classnames('subheading', 'small', ownClasses['small-title-text']) }, children)));
};

export { BigTitle, SmallTitle };
//# sourceMappingURL=ItemTitle.js.map
